import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { markAdminNotificationRead } from "../../actions/adminNotificationActions";
import { getAdminNotificationHref, getNotificationId, getNotificationTypeLabel } from "../../utils/adminNotificationUtils";

const AdminNotificationItem = ({ data, onOpenNotification }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const { title, message, isRead, createdAt } = data;
    const href = getAdminNotificationHref(data, user);

    const handleRead = async (openObject = false) => {
        if (busy) return;
        setBusy(true);
        setError("");
        const ok = isRead || await dispatch(markAdminNotificationRead(getNotificationId(data)));
        setBusy(false);
        if (!ok) {
            setError("Не удалось отметить уведомление. Попробуйте ещё раз.");
            return;
        }
        if (openObject) onOpenNotification(data);
    };

    const date = new Date(createdAt);
    const formattedDate = Number.isNaN(date.getTime()) ? "" : date.toLocaleString("ru-RU", {
        day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit",
    });

    return (
        <article className={"notification-item " + (isRead ? "read" : "unread")}>
            <div className="notification-item__header">
                <span className="notification-item__type">{getNotificationTypeLabel(data.type)}</span>
                <time className="notification-item__date">{formattedDate}</time>
            </div>
            <strong className="notification-item__title">{title}</strong>
            <p className="notification-item__message">{message}</p>
            <div className="notification-item__footer">
                {isRead ? <span className="notification-item__status">Прочитано</span> : (
                    <button type="button" className="notification-item__read" disabled={busy} onClick={() => handleRead()}>
                        {busy ? "Сохранение…" : "Прочитано"}
                    </button>
                )}
                {href && (
                    <button type="button" className="notification-item__link" disabled={busy} onClick={() => handleRead(true)}>
                        Открыть
                    </button>
                )}
            </div>
            {error && <p className="notification-item__error" role="alert">{error}</p>}
        </article>
    );
};

export default AdminNotificationItem;
